import { FilePdfOutlined } from "@ant-design/icons";
import { Image } from "antd";
import { companionIsSelfModerationRejected, type CompanionMessageRow } from "./CompanionRoomType";
import { resolveAppMediaUrl } from "../../utils/resolveAppMediaUrl";
import { CsMessageTextContent } from "../../components/customer-service-chat/CsMessageTextContent";
import "./CompanionRoomStyle.css";

function displayFileName(m: CompanionMessageRow): string {
  const n = m.fileName?.trim();
  if (n) return n;
  if (m.messageType === "PDF") return "PDF文件";
  if (m.messageType === "IMAGE") return "图片";
  if (m.messageType === "STICKER") return "表情";
  return "";
}

function moderationHint(m: CompanionMessageRow): string | null {
  if (companionIsSelfModerationRejected(m)) return null;
  const s = m.moderationStatus?.trim();
  if (s === "REJECTED") return "审核未通过";
  return null;
}

export function CompanionRoomMessageContent(props: {
  m: CompanionMessageRow;
  onOpenPdf?: (url: string, name: string) => void;
}): JSX.Element {
  const { m, onOpenPdf } = props;
  const deleted = Boolean(m.deleted);
  const shielded = Boolean(m.shielded);
  const modHint = moderationHint(m);
  const strikeSelfRejected = companionIsSelfModerationRejected(m);
  const blockCls = strikeSelfRejected ? "crm-msg-block crm-msg-block--self-rejected" : "crm-msg-block";

  if ((m.messageType === "IMAGE" || m.messageType === "STICKER") && m.fileUrl?.trim()) {
    const src = resolveAppMediaUrl(m.fileUrl) ?? m.fileUrl;
    return (
      <div className={blockCls}>
        {deleted ? (
          <span className="crm-msg-deleted">已撤回</span>
        ) : shielded ? (
          <span className="crm-msg-shielded">已屏蔽</span>
        ) : (
          <>
            <Image
              src={src}
              alt={displayFileName(m) || (m.messageType === "STICKER" ? "表情" : "图片")}
              className="crm-msg-image"
              preview={{ mask: false, destroyOnHidden: true }}
            />
            {modHint ? <div className="crm-msg-mod-hint">{modHint}</div> : null}
          </>
        )}
      </div>
    );
  }

  if (m.messageType === "PDF" && m.fileUrl?.trim()) {
    const name = displayFileName(m);
    return (
      <div className={blockCls}>
        {deleted ? (
          <span className="crm-msg-deleted">已撤回</span>
        ) : shielded ? (
          <span className="crm-msg-shielded">已屏蔽</span>
        ) : (
          <>
            <button
              type="button"
              className="crm-pdf-card"
              onClick={() => onOpenPdf?.(m.fileUrl ?? "", name || "PDF")}
            >
              <FilePdfOutlined className="crm-pdf-ic" />
              <span className="crm-pdf-name">{name || "PDF"}</span>
              <span className="crm-pdf-hint">在线查看</span>
            </button>
            {modHint ? <div className="crm-msg-mod-hint">{modHint}</div> : null}
          </>
        )}
      </div>
    );
  }

  return (
    <div className={blockCls}>
      {deleted ? (
        <span className="crm-msg-deleted">已撤回</span>
      ) : shielded ? (
        <span className="crm-msg-shielded">已屏蔽</span>
      ) : (
        <>
          <CsMessageTextContent content={m.content ?? ""} />
          {modHint ? <div className="crm-msg-mod-hint">{modHint}</div> : null}
        </>
      )}
    </div>
  );
}
